/**
 * @generated SignedSource<<234217ed51fc692c2d3a292ec2cde510>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DelegateCardEditMutation$variables = {
  delegateId: string;
  expiryNew: string;
};
export type DelegateCardEditMutation$data = {
  readonly editDelegate: {
    readonly delegate: {
      readonly expiryDate: string | null;
      readonly id: string;
    } | null;
    readonly error: string | null;
    readonly ok: boolean | null;
  } | null;
};
export type DelegateCardEditMutation = {
  response: DelegateCardEditMutation$data;
  variables: DelegateCardEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "delegateId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "expiryNew"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "delegateId",
            "variableName": "delegateId"
          },
          {
            "kind": "Variable",
            "name": "expiryNew",
            "variableName": "expiryNew"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "EditDelegatePayload",
    "kind": "LinkedField",
    "name": "editDelegate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Delegation",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiryDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegateCardEditMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DelegateCardEditMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2a0f4aa6a9a3f1142c9023b61398889",
    "id": null,
    "metadata": {},
    "name": "DelegateCardEditMutation",
    "operationKind": "mutation",
    "text": "mutation DelegateCardEditMutation(\n  $delegateId: ID!\n  $expiryNew: DateTime!\n) {\n  editDelegate(input: {delegateId: $delegateId, expiryNew: $expiryNew}) {\n    ok\n    error\n    delegate {\n      id\n      expiryDate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "efb16ba3d722cca8a1684be7578aff77";

export default node;
